import React from 'react'
import { Stack } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { useActivityStream } from './activity-stream-form-logic'
import { ActivityStreamPresentation } from './activity-stream-form-presentation'

/**
 * ACTIVITY STREAM tab on the master-trade detail page (ADR_LOS-028, LOS-4253 Phase 1).
 *
 * Notes are scoped to a sub-trade; this view aggregates them across the master trade's
 * sub-trades, which is safe because the agency is party to all of them.
 */
export function ActivityStreamTradeEntry() {
  const { tradeId } = useParams()
  const stream = useActivityStream(tradeId)

  return (
    <Stack w="100%" className="sectionDetailTradeBody noHeader">
      <ActivityStreamPresentation stream={stream} />
    </Stack>
  )
}
